module.exports = __webpack_public_path__ + "img/by.f9a2f28.svg";